import type { HTMLAttributes, ReactNode } from 'react';
import styles from './Surface.module.css';

export type SurfaceTone = 'plain' | 'raised' | 'interactive' | 'inset';

export type SurfaceProps = HTMLAttributes<HTMLElement> & {
  as?: 'article' | 'div' | 'li' | 'section';
  tone?: SurfaceTone;
  padding?: 'none' | 'compact' | 'normal';
  children: ReactNode;
};

const TONE_CLASS: Record<SurfaceTone, string> = {
  plain: styles.plain ?? '',
  raised: styles.raised ?? '',
  interactive: styles.interactive ?? '',
  inset: styles.inset ?? '',
};

export function Surface({
  as: Tag = 'section',
  tone = 'raised',
  padding = 'normal',
  className,
  children,
  ...rest
}: SurfaceProps): ReactNode {
  const classes = [
    styles.surface,
    TONE_CLASS[tone],
    padding === 'none'
      ? styles.paddingNone
      : padding === 'compact'
        ? styles.paddingCompact
        : styles.paddingNormal,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag className={classes} {...rest}>
      {children}
    </Tag>
  );
}
